<template>
    <v-dialog v-model="dialog" @keydown.esc="closeModal()" persistent max-width="1200px">
        <template v-slot:activator="{ on }"> 
            <v-btn  outlined color="#FFFFFF" class="ml-3" x-large dark v-on="on">
                Presenteie os Papais
            </v-btn> 
        </template>
            <v-card>
                <v-card-text>
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col order="1" cols="12">
                            <span class="title"> Dados Para Entrega</span>
                            <v-textarea v-model="end" readonly auto-grow></v-textarea>
                        </v-col>    
                        <v-col order="2" cols="12">
                            <v-row>
                                <v-col v-for="(item,idx) in this.listaPresentes" :key="idx" cols="12" xl="2" md="2" lg="2"> 
                                    <v-row justify="center" align-content="center" dense>
                                        <v-col cols="3"></v-col>
                                        <v-col cols="6" class="text-center">
                                            <v-img :src="item.imagem" max-width="100px"> </v-img>                               
                                        </v-col>
                                        <v-col cols="3"></v-col>
                                        <v-col cols="12" class="text-center">      
                                            <span class="title"> {{item.nome}} </span>
                                        </v-col>
                                        <v-col cols="12" class="text-center">
                                            <a :href="'//'+ item.link" target="_blank"> Click para Visitar o Link </a>             
                                        </v-col>
                                    </v-row>                 
                                </v-col>                                 
                            </v-row>
                        </v-col>                          
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>            
                    <v-btn color="blue darken-1" text @click="closeModal">Fechar</v-btn>
                </v-card-actions>                 
            </v-card>
    </v-dialog>
</template>
<script>

export default {
    props: ['endereco', 'presentes'],
    data: () => ({
        rules: {
            required: value => !!value || 'Campo Obrigatório.', 
        },
        end: '',
        dialog: false,
        listaPresentes: []
    }),
    created(){
        this.end = this.endereco
        this.listaPresentes = this.presentes
    },
    methods:{
        closeModal(){
          this.dialog = false
        },        
    }   
}
</script>